import styled, { css } from 'styled-components';
import { Layout } from 'antd';

export const LayoutMain = styled(Layout)<{ $isCollapse: boolean }>`
  background: ${({ theme }) =>
    theme?.colors?.layoutContentBackground} !important;
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  .site-layout {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    transition: all 0.2s ease-in-out;
  }

  .ant-layout-content {
    padding: 16px;
    background-color: ${({ theme }) => theme?.colors?.layoutContentBackground};
    margin-left: 80px;
    min-height: calc(100vh - 64px);
    min-width: 0;
    max-width: calc(100vw - 80px);
    box-sizing: border-box;
    overflow-x: hidden;
    transition: margin-left 0.2s ease-in-out, max-width 0.2s ease-in-out;

    @media ${({ theme }) => theme?.breakpoints?.mdMax} {
      padding: 20px 15px;
      max-width: 100vw;
    }

    ${({ $isCollapse }) =>
      !$isCollapse &&
      css`
        margin-left: 260px;
        max-width: calc(100vw - 260px);
        @media ${({ theme }) => theme?.breakpoints?.mdMax} {
          margin-left: 80px;
          max-width: calc(100vw - 80px);
        }
      `}
  }

  .ant-layout-sider-children {
    position: relative;
    @media ${props => props.theme.breakpoints.mdMax} {
      /* position: fixed !important;
      width: 100vw !important;
      height: 100vh !important; */
    }
  }

  .ant-layout-sider {
    background-color: ${({ theme }) => theme?.colors?.cardBackground || '#fff'} !important;
    border-right: 1px solid ${({ theme }) => theme?.colors?.borderCard || '#e8e8e8'} !important;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    height: 120vh;

    z-index: 99;
    @media ${props => props.theme.breakpoints.mdMax} {
      width: 100vw !important;
      height: 100vh !important;
    }

    .logo {
      color: ${({ theme }) => theme?.colors?.textColor || '#333'};
      height: 64px;
      border-bottom: 1px solid ${({ theme }) => theme?.colors?.borderCard || '#e8e8e8'};

      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .collapse-custom {
        width: 26px;
        height: 26px;
        overflow: hidden;
        position: absolute;
        box-shadow: 0px 2px 8px rgba(0, 110, 182, 0.4);
        border-radius: 50%;
        cursor: pointer;
        right: -12px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.95;
        background-color: #006EB6;
        transition: all 0.3s ease;

        &:hover {
          opacity: 1;
          background-color: #005082;
          transform: scale(1.1);
        }

        svg {
          font-size: 12px;
          fill: #ffffff;
        }
        @media ${props => props.theme.breakpoints.mdMax} {
          right: 0;
        }
      }
    }
  }

  .switch-module {
    margin-right: 20px;

    .selectbox-modules {
      .ant-select-selector {
        background-color: #f1f1f1;
        padding: 3px 10px;
        height: auto;
      }
    }

    span {
      margin-right: 4px;
    }

    .ant-dropdown-trigger {
      border: none;
      padding: 6px 8px;
      cursor: pointer;
      border-radius: 4px;
      font-weight: 600;
    }

    &.module-mobile {
      display: none;
      margin-right: 0;
    }

    @media ${props => props.theme.breakpoints.smMax} {
      display: none;

      &.module-mobile {
        display: block;
        margin-bottom: 20px;
      }
    }
  }

  .menu-sidebar {
    height: calc(100vh - 124px);
    padding: 22px 4px;
    padding-top: 30px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    @media ${props => props.theme.breakpoints.mdMax} {
      &::-webkit-scrollbar {
        width: 0;
      }
    }

    .ant-menu {
      padding: 0;
      background-color: transparent;
      border-right: none !important;
      border-inline-end: none !important;

      li {
        margin: 0;
        width: 100%;
        color: ${({ theme }) => theme?.colors?.textColorGray || '#555'};
        font-size: 13px;
        background: none;
      }

      .ant-menu-inline {
        background-color: transparent;
      }
      
      .ant-menu-item {
        width: calc(100% - 16px);
        margin: 4px 8px !important;
        border-radius: 8px;
      }

      .ant-menu-item-selected,
      .ant-menu-item:hover,
      .ant-menu-item:active,
      .ant-menu-submenu-title:active {
        background-color: rgba(0, 110, 182, 0.15) !important;
        color: #006EB6 !important;
      }

      .ant-menu-item-active {
        color: #006EB6 !important;
      }

      .ant-menu-submenu-active {
        .ant-menu-submenu-title {
          color: #006EB6 !important;
        }
      }

      .ant-menu-submenu {
        .ant-menu-submenu-title {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
        }
      }

      .ant-menu-submenu-selected {
        .ant-menu-submenu-title {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
          background-color: rgba(0, 110, 182, 0.15);
          color: #006EB6;
        }
      }

      ${({ $isCollapse }) =>
        $isCollapse &&
        css`
          .ant-menu-item-group-title {
            height: 0;
            padding: 0;
            margin: 0;
            overflow: hidden;
            opacity: 0;
          }
        `}

      svg {
        font-size: 16px;
      }
    }
  }

  .logout {
    height: 60px;
    padding: 10px;

    button {
      padding: 10px;
      width: 100%;
      border: 1px solid ${({ theme }) => theme?.colors?.borderCard || '#e8e8e8'};
      background-color: ${({ theme }) => theme?.colors?.cardBackground || '#fff'};
      color: ${({ theme }) => theme?.colors?.textColorGray || '#555'};
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        color: #006EB6;
        border-color: #006EB6;
      }
    }
  }
`;

export const Header = styled.header<{ $isCollapse: boolean }>`
  background-color: ${({ theme }) => theme?.colors?.cardBackground};
  box-shadow: ${({ theme }) => theme?.colors?.boxShadowHeader};
  position: sticky;
  top: 0;
  height: 64px;
  // overflow: hidden;
  z-index: 9;

  h2 {
    color: ${({ theme }) => theme?.colors?.textColor || '#333'};
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  padding-left: 120px;

  ${({ $isCollapse }) =>
    !$isCollapse &&
    css`
      padding-left: 292px;
      @media ${({ theme }) => theme?.breakpoints?.mdMax} {
        padding-left: 120px;
      }
    `}

  .left {
    flex-basis: 70%;
    display: flex;
    align-items: center;

    .inp-search {
      width: 300px;
      border: 1px solid #c1c1c1;
      padding: 4px;
    }
  }

  .right {
    display: flex;
    align-items: center;

    .ant-badge {
      .ant-avatar {
        background: ${({ theme }) => theme?.colors?.neutralGray5};
        cursor: pointer;
        margin-left: 20px;

        svg {
          color: #000;
        }
      }
    }

    .ant-switch {
      margin-left: 20px;
    }
  }
`;

export const Logo = styled.img<{ $isSmall: boolean }>`
  max-width: 180px;
  max-height: 48px;
  object-fit: contain;

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      max-width: 40px;
      max-height: 40px;
    `}
`;

export const UserInfo = styled.div`
  .user-unit {
    display: flex;
    align-items: baseline;
    gap: 5px;
    min-width: max-content;
  }
`;

export const ContentWrapper = styled.div`
  background-color: ${({ theme }) => theme?.colors?.cardBackground || '#ffffff'};
  padding: 16px;
  min-height: calc(100vh - 96px);
  border: 1px solid ${({ theme }) => theme?.colors?.borderCard || '#e5e7eb'};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme?.colors?.boxShadowCard || '0px 1px 6px rgba(0, 0, 0, 0.1)'};
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
`;
